import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _ArticleGetter = Getter.of();
export const _ArticleResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _ArticleResponse2Article = _Response2ResponseData();
export const _Article2Data = Fold.compose(_ArticleGetter, Res._Response());
export const _Article2Attributes = Fold.compose(_Article2Data, Lens.prop("attributes"));
export const _ArticleAttributes2Alias = Fold.compose(_Article2Attributes, Lens.prop("alias"));
export const _ArticleAttributes2Description = Fold.compose(_Article2Attributes, Lens.prop("description"));
export const _ArticleAttributes2Hints = Fold.compose(_Article2Attributes, Lens.prop("hints"));
export const _ArticleAttributes2Name = Fold.compose(_Article2Attributes, Lens.prop("name"));
export const _ArticleAttributes2PageMetadataDescription = Fold.compose(_Article2Attributes, Lens.prop("pageMetadataDescription"));
export const _ArticleAttributes2Published = Fold.compose(_Article2Attributes, Lens.prop("published"));
export const _ArticleAttributes2State = Fold.compose(_Article2Attributes, Lens.prop("state"));
export const _ArticleAttributes2Title = Fold.compose(_Article2Attributes, Lens.prop("title"));
export const _Article2Body = Fold.compose(_ArticleGetter, Res._Rel("body"), Res._ForEach());

